'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var cartProductComponent = exports.cartProductComponent = {
    template: require('./cart-product.html'),
    bindings: {
        product: '=',
        sellerId: '<',
        sellerName: '<',
        isVipSeller: '<',
        removeProducts: '&',
        quantityChanged: '&',
        openProductDiscounts: '&',
        parentState: '<'
    },
    controllerAs: 'vm',
    controller: ["productService", "authService", function controller(productService, authService) {
        'ngInject';

        var vm = this;
        vm.openProductDiscounts = openProductDiscounts;
        vm.closeProductDiscounts = closeProductDiscounts;
        vm.toggleProductDiscounts = toggleProductDiscounts;
        vm.removeProductsFromList = removeProductsFromList;
        vm.productDiscounts = {};
        vm.isFebelcoCustomer = isFebelcoCustomer;

        function openProductDiscounts(product) {
            if (!product.isDisabled) {
                vm.productDiscountsOpen = true;
                if (Object.keys(vm.productDiscounts).length === 0) {
                    vm.productDiscountsLoading = true;
                    productService.getProductDiscounts(product.id).then(function (result) {
                        vm.productDiscountsLoading = false;
                        vm.productDiscounts = productService.formatProductDiscount(result);
                    });
                }
            }
        }

        function toggleProductDiscounts(product) {
            if (vm.product.maxDiscount !== null || vm.product.portalContractTypeCode === 'AGIOS') {
                if (vm.productDiscountsOpen) {
                    closeProductDiscounts();
                } else {
                    openProductDiscounts(product);
                }
            }
        }

        function closeProductDiscounts() {
            vm.productDiscountsOpen = false;
        }

        function removeProductsFromList(products) {
            vm.removeProducts({ $event: products });
        }

        function isFebelcoCustomer() {
            return authService.isFebelcoCustomer;
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/checkout/components/cart-product.js
// module id = 906
// module chunks = 0